import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import LifetimeStats from "components/LifetimeStats";
import WorkoutDetails from "components/VetActivity/Workouts/WorkoutDetails";
import { EWorkoutView } from "components/VetActivity/Workouts/WorkoutDetails/WorkoutDetails";
import { transformViewDate } from "utils/date-utils";
import ExamsTablePPsRow from "./ExamsTablePPsRow";

import useStyles from "./styles";

interface IProps {
  horse: racehorse360.IHorse;
}

const ExamsTablePPs = (props: IProps) => {
  const { lastFivePastPerformances, lifetime, lastFourWorkouts } = props.horse;

  const classes = useStyles();

  const renderPPsTable = () => {
    if (lastFivePastPerformances?.length) {
      return (
        <div className={classes.ppsTable}>
          {lastFivePastPerformances.map(pp => (
            <ExamsTablePPsRow key={pp.id} data={pp} />
          ))}
        </div>
      );
    }
  };

  const renderLastWorkouts = () => {
    if (lastFourWorkouts?.length) {
      return lastFourWorkouts.map(workout => (
        <div key={workout.id} className={classes.lastWorkout}>
          <span>
            {transformViewDate(workout.date, null, "dd MMM yy")}&nbsp;
          </span>
          <span>{workout.track}</span>
          <WorkoutDetails
            workout={workout}
            view={EWorkoutView.WORKOUT_REQUEST_VIEW}
          />
        </div>
      ));
    }
  };

  return (
    <div className={classes.pastPerformances}>
      <LifetimeStats
        rootClassName={classes.lifetimeStats}
        lifetime={lifetime}
      />

      {renderPPsTable()}

      <div className={classes.lastWorkouts}>{renderLastWorkouts()}</div>
    </div>
  );
};

export default React.memo(ExamsTablePPs);
